import CacheTag from '@/redux/services/cacheTags';
import { customSubscriptionConfigurationsApi as generatedCustomSubscriptionConfigurationsApi } from '../endpoints/customSubscriptionConfigurations';

export const customSubscriptionConfigurationsApi =
  generatedCustomSubscriptionConfigurationsApi.enhanceEndpoints({
    endpoints: {
      listCustomSubscriptionConfigurations: {
        providesTags: [{ type: CacheTag.ListCustomSubscriptionConfigurations }],
      },
      createCustomSubscriptionConfiguration: {
        invalidatesTags: [
          { type: CacheTag.ListCustomSubscriptionConfigurations },
          { type: CacheTag.Nsb },
        ],
      },
      listAvailableCustomSubscriptionConfigurationNsbs: {
        providesTags: [{ type: CacheTag.Nsb }],
      },
      getCustomSubscriptionConfiguration: {
        providesTags: (_result, _error, queryArg) => [
          {
            type: CacheTag.GetCustomSubscriptionConfiguration,
            id: queryArg.id,
          },
        ],
      },
      deleteCustomSubscriptionConfiguration: {
        invalidatesTags: [
          { type: CacheTag.ListCustomSubscriptionConfigurations },
          { type: CacheTag.Nsb },
        ],
      },
      updateCustomSubscriptionConfigurationEntry: {
        invalidatesTags: (_result, _error, queryArg) => [
          { type: CacheTag.GetCustomSubscriptionConfiguration, id: queryArg.id },
        ],
      },
      deleteCustomSubscriptionConfigurationEntry: {
        invalidatesTags: (_result, _error, queryArg) => [
          { type: CacheTag.GetCustomSubscriptionConfiguration, id: queryArg.id },
        ],
      },
      createCustomSubscriptionConfigurationEntry: {
        invalidatesTags: (_result, _error, queryArg) => [
          {
            type: CacheTag.GetCustomSubscriptionConfiguration,
            id: queryArg.configurationId,
          },
        ],
      },
    },
  });

export type {
  ConfigurationEntryDto,
  CreateCustomSubscriptionConfigurationEntryRequest,
  CreateCustomSubscriptionConfigurationRequest,
  CustomSubscriptionConfigurationDto,
  CustomSubscriptionConfigurationWithEntriesDto,
  NsbDto,
  UpdateCustomSubscriptionConfigurationEntryRequest,
} from '../endpoints/customSubscriptionConfigurations';
export { CustomSubscriptionConfigurationEntryType } from '../endpoints/customSubscriptionConfigurations';

export const {
  useListCustomSubscriptionConfigurationsQuery,
  useLazyListCustomSubscriptionConfigurationsQuery,
  useCreateCustomSubscriptionConfigurationMutation,
  useListAvailableCustomSubscriptionConfigurationNsbsQuery,
  useLazyListAvailableCustomSubscriptionConfigurationNsbsQuery,
  useGetCustomSubscriptionConfigurationQuery,
  useLazyGetCustomSubscriptionConfigurationQuery,
  useDeleteCustomSubscriptionConfigurationMutation,
  useUpdateCustomSubscriptionConfigurationEntryMutation,
  useDeleteCustomSubscriptionConfigurationEntryMutation,
  useCreateCustomSubscriptionConfigurationEntryMutation,
} = customSubscriptionConfigurationsApi;
